import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from './container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faServer,
  faLock,
  faShieldAlt,
  faGlobe,
  faCloudUploadAlt,
  faBolt,
  faDatabase,
  faNetworkWired
} from '@fortawesome/free-solid-svg-icons';

const HostingSection = () => {
  const { t } = useTranslation('home');
  
  // Map icon names to FontAwesome icons
  const iconMap = {
    'server': faServer,
    'lock': faLock,
    'shield': faShieldAlt,
    'globe': faGlobe,
    'cloud': faCloudUploadAlt,
    'bolt': faBolt,
    'database': faDatabase,
    'network': faNetworkWired
  };
  
  // Get icon for bullet point based on icon property
  const getIconForBullet = (bullet, index) => {
    // If bullet is an object with icon property, use that icon
    if (typeof bullet !== 'string' && bullet.icon && iconMap[bullet.icon]) {
      return iconMap[bullet.icon];
    }
    
    // Fallback to the index-based assignment for backward compatibility
    return iconMap[Object.keys(iconMap)[index % Object.keys(iconMap).length]];
  };
  
  return (
    <Container>
      <div className="w-full">
        <div className="mb-12">
          <div className="flex flex-col items-center lg:items-start">
            <h2 className="text-3xl font-bold text-center lg:text-left">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary to-cyan-500">
                {t('c3.hosting')}
              </span>
            </h2>
            <div className="h-1 w-24 bg-gradient-to-r from-primary to-transparent mt-3 rounded-full"></div>
            <p className="text-lg md:text-xl max-w-3xl mt-4 md:mt-6 text-gray-300 text-center lg:text-left">
              {t('c3.description')}
            </p>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {t('c3.hosting_bulletpoints', { returnObjects: true }).map((bullet, index) => (
            <div 
              key={index} 
              className="card-hover bg-gradient-to-br from-gray-800/80 to-gray-900/80 
                      p-6 rounded-xl border border-gray-700/50 hover:border-primary/30
                      flex items-start shadow-lg"
            >
              <div className="flex-shrink-0 mr-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
                  <FontAwesomeIcon 
                    icon={getIconForBullet(bullet, index)} 
                    className="text-primary text-xl" 
                  />
                </div>
              </div>
              <div>
                {typeof bullet === 'string' ? (
                  <p className="text-base text-gray-200">{bullet}</p>
                ) : (
                  <p className="text-base text-gray-200">
                    {bullet.link ? (
                      <a 
                        href={bullet.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:text-primary/90 border-b border-primary/30 hover:border-primary transition-colors duration-300"
                      >
                        {bullet.text}
                      </a>
                    ) : (
                      bullet.text
                    )}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default HostingSection;